import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';

@Component({
    selector: 'st-check-box',
    templateUrl: './check-box.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-checkbox',
    },
})
export class CheckBoxComponent extends EnpsControlComponent<boolean> {
    public valueChanged(v: MatCheckboxChange) {
        this.changed.emit(v.checked);
    }
}
